module.exports = __webpack_public_path__ + "img/value.9f2e613f.png";